import { render } from "./SocialLinks.vue?vue&type=template&id=645b30b2&scoped=true"
import script from "./SocialLinks.vue?vue&type=script&lang=js"
export * from "./SocialLinks.vue?vue&type=script&lang=js"

import "./SocialLinks.vue?vue&type=style&index=0&id=645b30b2&scoped=true&lang=css"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645b30b2"]])

export default __exports__